module["exports"] = [
  "North",
  "East",
  "West",
  "South",
  "New",
  "Lake",
  "Port"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/city_prefix.js
// module id = 1544
// module chunks = 0